<template>
  <section class="section-graph">
    <div class="chart-wrapp" style="max-width: 100%;">
      <div class="weather-graph-start">
        <highcharts :key="componentKey" :options="chartOptions" :constructor-type="'stockChart'"></highcharts>
      </div>
    </div>
  </section>
</template>

<script>
import { Chart } from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'
import Highcharts from 'highcharts'
import '../../../node_modules/flatpickr/dist/themes/dark.css'
import '../../assets/css/js-datapicer.scss'
import graphConfigs from '../graphConfigs'
import api from '../../api/api'
import moment from 'moment'
import object from 'lodash/object'

stockInit(Highcharts)

export default {
  name: 'PerformanceRatio',
  mixins: [graphConfigs],
  components: {
    'highcharts': Chart
  },
  props: {
    productionAC: Array
  },
  data () {
    return {
      powerDC: 14767,
      haveData: false,
      componentKey: 1,
      dateTime: null,
      loading: false,
      delta: 7,
      dateFrom: moment()
        .subtract(6, 'days')
        .format('YYYY-MM-DD' + ' 00:00:00'),
      dateTo: moment().format('YYYY-MM-DD HH:mm:ss'),
      dateError: '',
      chartOptions: {
        chart: {
          type: 'column',
          marginLeft: 30
        },
        rangeSelector: {
          buttonSpacing: 5,
          inputEnabled: false

        },
        series: [
          {
            data: [],
            name: 'Total power production'
          }
        ],
        tooltip: {
          dateTimeLabelFormats: {
            millisecond: '%A, %b %e'
          }
        },
        yAxis: [
          { // Primary yAxis
            labels: {
              format: '{value} ',
              style: {
                color: '#fff'
              }
            },
            title: {
              text: 'PR',
              style: {
                color: '#fff'
              }
            },
            opposite: true,
            gridLineColor: '#595c5e'
          }
        ]
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  beforeDestroy () {
    clearInterval(this.polling)
  },
  methods: {
    forceRerender () {
      this.componentKey += 1
    },
    fetchData () {
      let _this = this
      let station = this.$store.getters[ 'station/station' ]
      this.powerDC = Math.round(parseFloat(String(station.dcPower).replace(',', '.')) * 1000)
      let productionAC = this.productionAC.slice(this.productionAC.length - this.delta)
      console.log(this.dateFrom, this.dateTo)
      let devices = {}
      let insolation
      let sensor = station.meteo.solar_plane
      let param = 'IO_SENSOR1_DATA'
      if (_this.loading) {
        return
      }
      _this.loading = true
      object.set(devices, sensor, [param])
      api.post('/station-data/' + station.id, {
        'devices': devices,
        'from': _this.dateFrom,
        'to': _this.dateTo
      }).then((q) => {
        object.forOwn(q.data, (value) => {
          let prevY = null
          let prevX = null
          let result = []
          let step = null
          let day = null
          let dayBefore = null
          // eslint-disable-next-line no-unused-vars
          let i = 0
          let dateP = null
          let productionACNowe = []
          value.forEach((value) => {
            day = moment(value[0]).format('YYYY-MM-DD')
            if (prevY !== null) {
              step += Math.abs(Math.round(value[ 1 ] * ((value[ 0 ] - prevX) / (60 * 60 * 1000)) * 100) / 100000)
              dayBefore = moment(prevX).format('YYYY-MM-DD')
            } else {
              step += 0
            }
            if (day !== dayBefore && dayBefore !== null) {
              productionACNowe = productionAC.find(power => {
                dateP = moment(power[0]).format('YYYY-MM-DD')
                console.log(dateP, dayBefore)
                return dateP === dayBefore
              })
              console.log(productionACNowe, moment(prevX).format('YYYY-MM-DD'), productionACNowe[1], (step * this.powerDC))
              productionACNowe = (productionACNowe !== undefined) ? productionACNowe[1] : 0
              result.push([prevX, productionACNowe / (step * this.powerDC)])
              step = 0
              i += 1
            }
            prevY = value[ 1 ]
            prevX = value[ 0 ]
          })
          productionACNowe = productionAC.find(power => {
            dateP = moment(power[0]).format('YYYY-MM-DD')
            console.log(dateP, dayBefore)
            return dateP === dayBefore
          })
          console.log(productionACNowe)
          productionACNowe = (productionACNowe !== undefined) ? productionACNowe[1] : 0
          result.push([prevX, productionACNowe / (step * this.powerDC)])
          console.log('result', result)
          insolation = result
        })
        _this.chartOptions.series[ 0 ].data = insolation
        _this.loading = false
        _this.haveData = true
        _this.forceRerender()
      })
    },
    pollData () {
      let _this = this
      this.polling = setInterval(() => {
        _this.fetchData()
      }, 60 * 1000)
    }
  }
}
</script>
